/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$( document ).ready(function() {
(function(){
    
    var tagsMenuBlogScroll = function() {
      if($(window).innerWidth() <= 1340) {
        var windowsTop = $(window).scrollTop();
        var articleTop = $(".Article__Content").offset().top;
        var diff = parseInt(articleTop - windowsTop);
        var hHeader = parseInt($("header").height()) + parseInt($("header").css("padding-top")) + parseInt($("header").css("padding-bottom")) + parseInt($(".ArticleToolbar.is-visible").height()) + parseInt($(".ArticleToolbar.is-visible").css("padding-top")) + parseInt($(".ArticleToolbar.is-visible").css("padding-bottom"));
        
        if(diff > hHeader){ $("#tagsFilter").css("top", diff); }
        else { $("#tagsFilter").css("top", hHeader);} 
      
        if($("#tagsFilter").not(".active")) {
          $("#tagsFilter").addClass("active");
        }
      }
    };
    var gotTopQuizz = function() {
      //var elem = $(".quizz-section");
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $(".slick-active input[type=radio]").each(function() {
        $(this).prop('checked', false); // Unchecks it
        //console.log("ok");
      });
    };
  $(".beauty_buddy_forms_wrapper form").on("submit", function(e){
    e.preventDefault();
    localStorage.setItem("useRedirect", true);
    $(this).off();
    $(this).submit();      
  });
  
  $('.slide_content_wrapper').on('click', 'input[type=radio], input[type=checkbox]', function() {
    if($(this).closest(".slide_content").hasClass("q4_content") && $(this).val() == "no"){
      $('.slide_content_wrapper')[0].slick.slickGoTo(5);
    } else if($(this).closest(".slide_content").hasClass("q5_content") && $(this).val() == "no"){
      $('.slide_content_wrapper')[0].slick.slickGoTo(7);
    }else{
      $('.slide_content_wrapper').slick('slickNext');
      gotTopQuizz();
    }



  });
  $('body').on('click', '.skip_slide', function(e) {
    e.preventDefault();
    $('.slide_content_wrapper').slick('slickNext');
    gotTopQuizz();

  });
  var $slick_slider = $('#shopify-section-related-products').find('.grid--view-items');
  var settings_slider = {
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: false
  }
  slick_on_mobile( $slick_slider, settings_slider);

  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 749) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  }; 

  //$('.fancybox_btn').fancybox();
  
  if($('body').hasClass('no_transform_page')) {
  var sticky_block_height = $('.sticky_result_block').outerHeight();
  var static_offsetTop_block = $('.sticky_result_block').offset().top;
  var static_offsetBottom_Block = static_offsetTop_block + sticky_block_height;
}

  $('.slide_content_wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
    switch (currentSlide) {
      case 0:
        $('#slide_content_prev_btn').addClass('hide');
        $('.slider_progress_bar_title').html('find your skin type…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(0).addClass('active');
        break;
      case 1:
        $('#slide_content_prev_btn').removeClass('hide');
        $('.slider_progress_bar_title').html('a little about you…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(0).addClass('active');
        break; 
      case 2:
        $('#slide_content_prev_btn').removeClass('hide');
        $('.slider_progress_bar_title').html('your skin…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(1).addClass('active');
        break; 
      case 3:
        $('#slide_content_prev_btn').removeClass('hide');
        $('.slider_progress_bar_title').html('more on your skin…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(1).addClass('active');
        break; 
      case 4:
        $('#slide_content_prev_btn').removeClass('hide');
        $('.slider_progress_bar_title').html('let’s go deeper…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(1).addClass('active');
        break; 
      case 5:
        $('#slide_content_prev_btn').removeClass('hide');
        $('.slider_progress_bar_title').html('define your skin…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(1).addClass('active');
        break;
      case 6:
        $('#slide_content_prev_btn').removeClass('hide');
        $('.slider_progress_bar_title').html('last question…');
        $('.progress_bar').find('li').removeClass('active');
        $('.progress_bar').find('li').eq(1).addClass('active');
        break;
    }
    sticky_block_height = $('.sticky_result_block').outerHeight();
    static_offsetTop_block = $('.sticky_result_block').offset().top;
    static_offsetBottom_Block = static_offsetTop_block + sticky_block_height;
    

  });


  $('.slide_content_wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	//console.log("beforeChange");
    if (nextSlide == 0 && currentSlide != 1 ) {
      var answers_text = $(".q3_content input:checked").val() + "_" + $(".q4_content input:checked").val() + "_" + $(".q5_content input:checked").val();
      var answers_value = "";
      var result_title = '',
          result_header_text = '';
      var show_collection = '';

      switch (answers_text) {
        case "no_no_no":
          var answers_value = "Normal";
          result_title = 'normal';
          show_collection = 'normal';
          result_header_text = '<ul><li>This is awesome, your skin is very well-balanced skin.</li><li>The overall sebum and moisture is balanced and the skin is neither too oily nor too dry.</li><li>Together, our goal is to keep the benefit of the basic moisture of your skin and keep it healthy.</li></ul>';
          break;
        case "no_no_yes":
          var answers_value = "Oily";
          result_title = 'oily';
           show_collection = 'oily';
          result_header_text = '<ul><li>Your skin tends to over produce sebum, leading to showing a regular shine.</li><li>As your skin is over producing sebum it may cause clogged pores, pimples, or skin that looks rough. Finding the perfect balance to protect your skin is essential.</li><li>It is therefore essential to treat your skin to keep it healthy.</li><li>Together, our goal is to fight effectively the shiny aspect of your skin and restore a fresh and matte complexion throughout the day, while keeping your skin moisturized.</li></ul>';
          break;
        case "no_yes_yes":
          var answers_value = "Mix";
          result_title = 'mixed';
            show_collection = 'mixed';
          result_header_text = '<ul><li>You can sometimes experience an excess of sebum production on the T-zone but dry everywhere else.</li><li>It is therefore essential to treat your skin to keep it healthy.</li><li>Together, our goal is to fight effectively the shiny aspect of your skin and restore a fresh and matte complexion throughout the day.</li></ul>';
          break;
        case "no_yes_no":
          var answers_value = "Dry";
          result_title = 'dry';
          show_collection = 'dry';
          result_header_text = '<ul><li>The major factor responsible for dry, scaly skin can therefore be related to the loss of water from the stratum corneum, which fluctuates with environmental humidity levels, damage to the barrier by denaturing keratin protein, removing NMF and interrupting lipid bilayers.</li><li>Dry skin arises from distress or damage to the skin’s lipid barrier -  structural deterioration exposes skin cells to external threats and contributes to trans-epidermal water loss as cells become dehydrated.</li><li>Together, our goal is to repair the skin’s functional barrier, lock in moisture, decrease sensitivity and increase hydration levels.</li></ul>';
          break;
        case "yes_no_no":
          var answers_value = "Sensitive";
          result_title = 'sensitive';
          show_collection = 'sensitive';
          result_header_text = '<ul><li>Because of the sensitive nature of your skin, the redness and warm-ups are sensations that you know well … As for the production of sebum, you are lucky because it is balanced.</li><li>It will therefore be important to adopt an adapted skincare routine that respects the fragility of your skin.</li><li>You should avoid harsh chemical-based skin care treatments, and can be caused by other skin conditions like rosacea or allergies.</li><li>Sensitive skin is easily inflamed, so it’s important to choose the right natural skin care for sensitive skin to avoid any adverse reactions.</li><li>Together, our goal is to soothe redness, preserve the original moisture of your skin, and especially protect it from external aggressions.</li></ul>';
          break;
        case "yes_no_yes":
          var answers_value = "Oily&Sensitive";
          result_title = 'sensitive & oily';
          show_collection = 'sensitive_oily';
          result_header_text = '<ul><li>As your skin is by nature sensitive &amp; oily, you might experience irritations, redness heat sensations at time and a shiny appearance.</li><li>As your skin is over producing sebum it may cause clogged pores, pimples, or skin that looks rough.</li><li>Finding the perfect balance to protect your skin is essential.</li><li>Together, our goal is to lighten and soften redness, but also to give a fresh, matte complexion that will last all day.</li></ul>';
          break;
        case "yes_yes_yes":
          var answers_value = "Mix&Sensitive";
          result_title = 'sensitive & mixed';
          show_collection = 'sensitive_mixed';
          result_header_text = '<ul><li>Having a sensitive skin type, you experience redness and heat sensations at time.</li><li>As of sebum production, it might feel that it is mostly concentrated on your T-zone.</li><li>Your skin is most likely to be dry and in need of more hydration.</li><li>Sensitive and dehydrated skin often has an altered lipid barrier, which makes it more reactive to external aggression.</li><li>Together our goal is to soften the redness, regulate the production of sebum, hydrate to restore the plumpness of your skin, and protect it from external aggressions.</li></ul>';
          break;
        case "yes_yes_no":
          var answers_value = "Dry&Sensitive";
          result_title = 'sensitive & dry';
          show_collection = 'sensitive_dry';
          result_header_text = '<ul><li>As your skin is by nature sensitive & dry, you might experience redness and squeaky sensations at time.</li><li>Your skin doesn’t produce as much sebum and your skin can often feels rough and tight.</li><li>Your skin feels also sensitive and dehydrated depending on the environment.</li><li>A sensitive skin with a dry nature results in an altered lipid barrier, which makes it more reactive to the slightest change.</li><li>Together, our goal is to lighten and soften redness, to nourish your skin permanently, while restoring the plumpness and protecting it from external aggressions.</li></ul>';
          break;     
      }

      $('.result_quizz_title').html(result_title);
      $('.header_answer_text').html(result_header_text);
      $('.beauty_collection.show_collection').removeClass('show_collection');
      $('.beauty_collection').each(function() {
        if($(this).hasClass(show_collection)) {
          $(this).addClass('show_collection');
        }
      });


      $('.page_beauty_buddy').find('.result_quizz').removeClass('hide_result');
      $('.page_beauty_buddy').find('.quizz-section').addClass('hidden_slide');
      $("html,body").scrollTop(0);

      /*if($(".quizz-section").data("customer") != ""){
        var customer_id = $(".quizz-section").data("customer");
        var url = "https://customer-tag-frenchpharmacy.herokuapp.com/api_call.php";
        var data = {
          "customer_id": customer_id,
          "tags": answers_value
        };

        $.ajax({
          type: "POST",
          url: url,
          data: data,
          cache: false
        });

      }*/

    }
	var q1 = $(".choose_gender input:checked").val();
    var q4 = $(".q4_content input:checked").val();
    var q5 = $(".q5_content input:checked").val();
    


    if(currentSlide == 5 && q4 == 'no' && nextSlide == 4 ) {    
      event.preventDefault();
      setTimeout(function(){
        $('.slide_content_wrapper')[0].slick.slickGoTo(3);
      },100);
    }
    /*
    if(currentSlide == 7 && q5 == 'no' && nextSlide == 6 ) {    
      event.preventDefault();
      setTimeout(function(){
        $('.slide_content_wrapper')[0].slick.slickGoTo(5);
      },100);
    }
  */


  });
  $('.form_tab_menu').on('click', 'a', function(e) {
    e.preventDefault();
    var tab = $(this).attr('href');
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
    $('.form_tab_content_wrapper').find('.form_tab_content').removeClass('active');
    $(tab).addClass('active');
  });

  function initSlick() {
    $('.slide_content_wrapper').slick({
      infinite: true, //was false
      arrows: true,
      dots: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      waitForAnimate: false,
      draggable:false,
      swipe:false,
      touchMove:0,
      prevArrow:'<button id="slide_content_prev_btn" class="hide" ><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)"></path></svg></button>'
    });
  }
  $('body').on('change', '#agree_with_rules', function() {
    if( $(this).prop('checked')) {
      $('#create_account_content').find('.create_btn').removeClass('disabled');
    } else {
      $('#create_account_content').find('.create_btn').addClass('disabled');
    }
  });
  $('body').on('click', '.start_quizz_btn', function(e) {
    e.preventDefault();
    $(this).closest('.first_page_quizz').hide();
    $('.quizz-section').removeClass('hidden_slide');
    initSlick();
    gotTopQuizz();

  });
  if($(".init_quizz_slider").length){
    initSlick();
  }
/*
  $('.mobile_result_tabs_menu').on('click', 'a', function(e) {
    e.preventDefault();
    var tab = $(this).attr('href');
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
    $('.result_quizz').find('.mobile_result_tabs_content').removeClass('active');
    $(tab).addClass('active');
  });
*/
  /*
  jQuery('#create_customer').submit(function(event) {
  event.preventDefault();
  var data = jQuery(this).serialize();

 //create new account
  jQuery.post('/account', data)
    .done(function(data){
    var logErrors = jQuery(data).find('.errors').text();

    //if there are errors show them in the html form
    if (logErrors != "" && logErrors != 'undefined'){
        jQuery('#create_customer .errors').html(logErrors);
        jQuery('#create_customer .errors').show();

    //if account creation is successful show checkout page
    }else{
       console.log('success');
      document.location.href = '/checkout';
    }
    }).fail(function(){console.log('error');});
   return false;
}); */
  $('body').on('click', '.start_over_btn', function(e) {
    e.preventDefault();
    if ($('.slide_content_wrapper').hasClass('slick-initialized')) {
    	$('.slide_content_wrapper').slick("unslick");
    }
    $(".quizz_btn_subscribe").find(".success").hide();
    $(".quizz_btn_subscribe").find(".emailForNoCustomer").hide();
    $(".quizz_btn_subscribe").find(".sendDiagnosticDisplayEmail").show();
    
    initSlick();
     $('.slide_content_wrapper')[0].slick.slickGoTo(0);
    $(".page_beauty_buddy").closest('.first_page_quizz').show();
    $('.quizz-section').removeClass('hidden_slide');
    $('.result_quizz').addClass('hide_result');
    gotTopQuizz();
  });
  $(".sendDiagnostic").click(function(e) {
    e.preventDefault();
    var email = $(this).data("email");
    var firstN = $(this).data("firstN");
    var lastN = $(this).data("lastN");
    var skinTypeAll = $("#mobile_result_products .show_collection").prop('class');
    var sku1 = $(".tagsLastQuestion1").find(".item_info_variant_sku").text();
    var sku2 = $(".tagsLastQuestion2").find(".item_info_variant_sku").text();
    skinTypeAll = skinTypeAll.replace('beauty_collection','');
    skinTypeAll = skinTypeAll.replace('show_collection','');
    skinTypeAll = skinTypeAll.replace(' ','');
    var skinType = skinTypeAll.replace('_',' ');

    _learnq.push(['identify', {
    '$email': email,
    '$first_name': firstN,
    '$last_name': lastN, 
      		'skin-type': skinType,
          'Product-rec_1': sku1,
          'Product-rec_2': sku2,
  }]);
    /*
   	var settings = {
 		"async": true,
 		"crossDomain": true,
 		"url":"https://a.klaviyo.com/api/v2/list/HwbEmA/subscribe",
 		"method": "POST",
		"headers": {
 			"content-type": "application/x-www-form-urlencoded",
 			"cache-control": "no-cache"
 		},
 		"data": {
 			"api_key":"pk_f107c3d328b1915c0bc4741e51266a8464",
 			"profiles": [
              {
            	"email": email
              }
              ]
 		}
    }; */
        var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": "HwbEmA", 
        "email": email
      }
    }
    $.ajax(settings).done(function (response) {
 		console.log(response);
    });
    $(this).parent().find(".success").show("fast");
    $(".sendDiagnostic").remove();
  });
	$(".sendDiagnosticDisplayEmail").click(function(e) {
    	e.preventDefault();
      $(this).hide();
      $(this).parent().find(".emailForNoCustomer").show("fast");
    });
    $("#emailForNoCustomer").on("submit", function(e){
    	var email = $(this).find("input").val();
      	var skinTypeAll = $("#mobile_result_products .show_collection").prop('class');
    	skinTypeAll = skinTypeAll.replace('beauty_collection','');
    	skinTypeAll = skinTypeAll.replace('show_collection','');
    	skinTypeAll = skinTypeAll.replace(' ','');
    	var skinType = skinTypeAll.replace('_',' ');
      	//var sku1 = $(".tagsLastQuestion1").find(".item_info_variant_sku").text();
        //var sku2 = $(".tagsLastQuestion2").find(".item_info_variant_sku").text();

      	_learnq.push(['identify', {
      		'$email': email,
      		'skin-type': skinType,
          //'Product-rec_1': sku1,
          //'Product-rec_2': sku2,
  		}]);
/*
   	var settings = {
 		"async": true,
 		"crossDomain": true,
 		"url":"https://a.klaviyo.com/api/v2/list/HwbEmA/subscribe",
 		"method": "POST",
		"headers": {
 			"content-type": "application/x-www-form-urlencoded",
 			"cache-control": "no-cache"
 		},
 		"data": {
 			"api_key":"pk_f107c3d328b1915c0bc4741e51266a8464",
 			"profiles": [
              {
            	"email": email
              }
              ]
 		}
    }; */
        var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": "HwbEmA", 
        "email": email
      }
    }
    $.ajax(settings).done(function (response) {
 		console.log(response);
    });

      	$(this).hide();
      	$(this).parent().find(".success").show("fast");
      	return false;
    });

  
	var iframeResize = function() {
	$('section.featuredVideoV2 iframe, iframe.featuredVideoV2').each(function(index, element) {
		var iframeAttW = $(this).prop('width');
		var iframeAttH = $(this).prop('height');
      	var ratio = iframeAttW / iframeAttH;
		var wParent = $(this).parent().width();
      	var hParent = $(this).parent().height();
		var newHIframe = parseInt(wParent / ratio);
		$(this).css('width',wParent).css('height', newHIframe);
      	$(this).parent().attr('data-height',hParent);
      	if(newHIframe < hParent) {
        	$(this).parent().css("height",newHIframe);
      	} else {
        	var dataParentH = $(this).parent().data('height');
        	if(dataParentH > 0 ) {
          	$(this).parent().css("height",dataParentH);
        	}
      	}
     })
    };
  var resizePopup = function() {
    var h = $(window).innerHeight();
    var w = $(window).innerWidth();
    var hMargin = parseInt(0.9*h);
    if(w < hMargin) hMargin = 0.9*w;
    var hPopup = $(".NewsletterPopup").height();
    if(hPopup == 0) { 
   		hPopup = 470;   
    }
    if(!$(".NewsletterPopup").hasClass("resized")) {
      	$(".NewsletterPopup").attr("data-height", hPopup);
    }
    if(hPopup > hMargin) {
      $(".NewsletterPopup").addClass("resized");
      $(".NewsletterPopup").width(hMargin).height(hMargin);
    }
    else {
      var dataH = $(".NewsletterPopup").attr("data-height");
      if(dataH < hMargin ) {
      	$(".NewsletterPopup").width(dataH).height(dataH);
      }
      else {
        $(".NewsletterPopup").width(hMargin).height(hMargin);
      }
    }
    
  };
var activeNewsletterPopup = function() {
	if(jQuery("#layerPopup").length > 0) {
		var CookiesFP = Cookies;
		if( CookiesFP.get('FPNewsletter') !== '1') { 
			if(!jQuery('#layerPopup').hasClass('active')) {
				jQuery('#layerPopup').addClass('active');
				CookiesFP.set('FPNewsletter', '1', { expires: 5 }); //expire in 15 days
			}
		}
	}
};
  $("#layerPopup .NewsletterPopup__Close").click(function(e) {
    jQuery('#layerPopup').removeClass('active');
  });
  var activeLayerPop = function() {
    jQuery('#layerPop').addClass('active');
  }
  if(jQuery("#layerPop").length > 0) {
    setTimeout(activeLayerPop, 5000);
  }
  jQuery("#layerPop .close, #layerPop .clickOutFrame").click(function(e) {
    jQuery('#layerPop').removeClass('active');
  });
  
  var scrollAfterNav = function() {
    if($("body.template-collection").length > 0 ) {
      var hashtag = window.location.search;
      if(hashtag.includes("?page=")) {
      	var w = $(window).innerWidth();
        var scrolltoClass;
        if(w >= 600 ) { scrolltoClass = '.FlexboxIeFix.onlyDesktop';}
        else { scrolltoClass = '.PageHeader.onlyMobile'; }
        var header = jQuery('#shopify-section-header').height();
        var offsetTo = jQuery(".CollectionMain").offset().top - header;
        jQuery('html, body').animate({scrollTop:offsetTo}, 1000);
      }
    }
  };
  	var f = function() {
      	if($(".featuredVideoV2").length > 0) { iframeResize(); }
      	if($("#layerPopup").length >0) { resizePopup(); }
	};
	$(".ProductForm .rc_radio__autodeliver").on( "click", function() {
		$(".shopify-payment-button").hide("fast");    
	});
    $(".ProductForm .rc_radio__onetime").on( "click", function() {
		$(".shopify-payment-button").show("fast");    
	});
    $('.Article_navigation .close, #tagsFilter').on('click',function(e) {
    	e.preventDefault();
        $('.Article').toggleClass("openMenu");
    });
    if($(".template-article").length > 0) {tagsMenuBlogScroll();}
  	activeNewsletterPopup();
  	window.onresize = f;
	f();
	scrollAfterNav();
      
  $(window).on('scroll', function() {
      if($(".template-article").length > 0) {tagsMenuBlogScroll();}
    
    });

  })(jQuery) 
}); 

// Slideshow custom
jQuery(document).ready(function($) {
  $.each($('.Slideshow__Carousel'), function(index, carousel) {
    var $carousel = $(carousel);
    
    $carousel.on('select.flickity', function(event, index) {
      var wrapper = $carousel.find('.flickity-viewport');
      var carouselCell = $(this).find('.Carousel__Cell.is-selected');
      var videoIframe = carouselCell.find('iframe');
      
      if (videoIframe.length) {
        // set video src
        if (videoIframe.attr('data-src')) {
          videoIframe.attr('src', videoIframe.attr('data-src')).removeAttr('data-src')
        }

        var k = Math.abs(wrapper.height() / wrapper.width() - videoIframe.data('height') / videoIframe.data('width'));

        carouselCell.css({
          height: 0,
          paddingBottom: wrapper.height() / wrapper.width() * 100 + '%'
        })

        videoIframe.css({
          position: 'absolute',
          top: 0,
          left: 0,
          height: (1 - k) * 100 + 100 + '%',
          width: 100 + '%',
          marginTop: -k / 2 * 100 + '%',
          marginBottom: -k / 2 * 100 + '%'
        })
      }
    });

    
    
    
    // $(window).on('resize', _.throttle(function() {
    //   $carousel.flickity().flickity('next', true, true);
    // }, 800))
  });
});

window.FP = {
  isMobile: function() {
    return navigator.userAgent.match(/Mobi/)
  },
  addToCart: function(variant_id, quantity) {
    quantity = quantity || 1;
  
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      beforeSend: function() {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
      }
    };
    
    jQuery.ajax(params).done(function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: !0,
        detail: {
          variant: variant_id,
          quantity: quantity
        }
      }));
    });
  }
};

// ajax add to cart
$('a[data-action="ajax-add-to-cart"]').on('click', function(e) {
  e.preventDefault();
  
  var $this = $(this);
  var id = $this.attr('data-variantid');
  var qty = $this.attr('data-qty') || 1;

  if (undefined == id) {
    return;
  }

  FP.addToCart(id, qty);
});



//collection
$('#gf-products').on('click','.addtocart', function(e) {
  e.preventDefault();
  
  var $this = $(this);
  var id = $this.attr('data-variantid');
  var qty = $this.attr('data-qty') || 1;

  if (undefined == id) {
    return;
  }

  FP.addToCart(id, qty);
});




/* Smile.io
jQuery(document).ready(function($) {
  if (FP.isMobile()) {
    setTimeout(function() {
      $('#smile-ui-container').fadeOut(400)
    }, 10 * 1000)
  }
});
*/





























var slideWrapper = $(".main-slider"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          });
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratio) {
  if (!iframes[0]) return;
  var win = $(".main-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: (width - playerWidth) / 2,
         top: 0
        });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: (height - playerHeight) / 2
      });
    }
  });
}

// DOM Ready
$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
    resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });
  slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
      // slideWrapper.slick("slickPlay");
    }
  });

  //start the slider
  slideWrapper.slick({
    fade:true,
    autoplay: true,
    autoplaySpeed:6000,
    lazyLoad:"progressive",
    slidesToShow: 1,
    speed:600,
    arrows:true,
    dots:false,
    prevArrow:'<button type="button" class="slick-prev"><svg role="presentation" viewBox="0 0 11 21"><polyline fill="none" points="8.5 1 1 8.5 8.5 16" stroke-width="2.25"></polyline></svg></button>' ,
    nextArrow:'<button type="button" class="slick-next"><svg role="presentation" viewBox="0 0 11 21"><polyline fill="none" points="1 1 8.5 8.5 1 16" stroke-width="2.25"></polyline></svg></button>',
    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
  });
  
  $('.selectioner .selected_country').on('click', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('active');
  });
  $('.selectioner .selector_country .option').on('click', function(e) {
    e.preventDefault();
    var international = $(this).attr("data-international");
    var flagTag = $(this).attr("value");
    var selected_country_text = $(this).find(".fflag").attr("title");
    //console.log(international); 
    //modify flag
    var selected = $(".widget_countries .selected_flag");
    var selected_country = $(".selected_country");
    selected.find("div").removeClass();
    selected_country.find(".fflag").removeClass();
    selected.find("div").addClass(flagTag);
    selected_country.find("span:not(.country_name)").addClass(flagTag);
    selected_country.find(".country_name").text(selected_country_text);
    $(".wrap_delivery_pop .country_name").text(selected_country_text);
    $(this).parents(".selectioner").removeClass('active');
    
    //modify delivery
    var delivery = $(".delivery_options");
    if(international == "true") {
      delivery.removeClass("domestic").addClass("international");
    } else {
      delivery.removeClass("international").addClass("domestic");
    }
    
  });
});

// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});